import { isFunction } from 'ggApp/types/common';

export const isPromise = <Payload = any>(promise: any): promise is Promise<Payload> => {
    return isFunction(promise?.then) && isFunction(promise?.catch) && isFunction(promise?.finally);
};
